export default __webpack_public_path__ + "static/AkebiaCares-HP-Access-Flashcard_Thumb-47d1241e5a0392b58ccea35b452e5d12.jpg";